/**
 * Container for an Menu View component.
 */
import React from 'react'
import { connect } from 'react-redux'
import { Dispatch, AnyAction } from 'redux'

import { RootStoreState } from '../../root/index'
import * as collectionListActions from '../../collectionlist/actions'
import { ScreenSection, CollectionItem, COLLECTION_ITEM_SUBTYPE_MENU } from '../../api/types'

export interface OwnProps {
	section: ScreenSection
	accountId?: number
}

export interface Props extends OwnProps {
	items: CollectionItem[]
	favoritesEnabled: boolean
}

export interface Actions {
	loadMenuDetails: (id: number, version: number, language: string, accountId?: number) => void
}

const mapStateToProps = (state: RootStoreState, ownProps: OwnProps): Props => {
	const { section } = ownProps

	const collectionItems = section.collection_id && state.collectionlist.collectionItems.get(section.collection_id)
	const items = collectionItems && collectionItems.items ? collectionItems.items : []

	return {
		...ownProps,
		items,
		favoritesEnabled: state.settings.appMetaData?.favorites_enabled || false,
	}
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): Actions => ({
	loadMenuDetails: (id: number, version: number, language: string, accountId?: number) => {
		dispatch(collectionListActions.loadCollectionItems({ id, version, language, subtype: COLLECTION_ITEM_SUBTYPE_MENU, accountId }))
	},
})

export default (Component: React.ComponentType<Props & Actions>) =>
	connect(mapStateToProps, mapDispatchToProps)(Component)
